import { useEffect, useState } from 'react';

const useClientPathname = () => {
  const [pathname, setPathname] = useState<string | null>(null);

  useEffect(() => {
    // Only run this on the client
    const updatePath = () => setPathname(window.location.pathname);

    // Initial set
    updatePath();

    // Handle browser navigation (back/forward)
    window.addEventListener('popstate', updatePath);

    // Patch pushState and replaceState to emit a custom event
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    const patch = (method: typeof window.history.pushState) => {
      return function (this: History, ...args: Parameters<typeof method>) {
        const result = method.apply(this, args);
        window.dispatchEvent(new Event('custom:navigation'));
        return result;
      };
    };

    window.history.pushState = patch(originalPushState);
    window.history.replaceState = patch(originalReplaceState);

    // Listen to custom event
    window.addEventListener('custom:navigation', updatePath);

    return () => {
      window.removeEventListener('popstate', updatePath);
      window.removeEventListener('custom:navigation', updatePath);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, []);

  return pathname;
};

export default useClientPathname;
